/**
 * ReadyStatesRow — «البوابة قبل النشر» 2026-10-13 (بند 2أ من أمر إكمال
 * الجولة C): صف أزرار الحالات الجاهزة الخمس (customer_metrics/prediction_log
 * — routes/customers_unified_list.py::METRIC_STATE_DEFS)، كل زر يعرض عدده
 * الحقيقي (GET /unified-list?kind=metric_state&segment_code=...&page_size=1
 * ← total) ويفتح نفس CustomerListModal (نسخ/تصدير/مسودة) المستخدَم في كل
 * مكان آخر بالمنصة — لا مسار عرض/عدّ موازٍ.
 */
import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import CustomerListModal from "../components/CustomerListModal";

export function ReadyStatesRow() {
  const [states, setStates] = useState([]); // [{key, label_ar, count}]
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [openState, setOpenState] = useState(null); // {key, label_ar}

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setErr(null);
      try {
        const defs = (await api.get("/customers/unified-list/metric-states")).data.states || [];
        const withCounts = await Promise.all(defs.map(async (d) => {
          try {
            const r = await api.get("/customers/unified-list", {
              params: { kind: "metric_state", segment_code: d.key, page_size: 1 },
            });
            return { ...d, count: r.data?.total ?? null };
          } catch (e) {
            return { ...d, count: null };
          }
        }));
        if (!cancelled) setStates(withCounts);
      } catch (e) {
        if (!cancelled) setErr(e?.response?.data?.detail || "تعذّر تحميل الحالات الجاهزة");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div data-testid="ready-states-row" dir="rtl"
         style={{ background: "#fff", border: "1px solid rgba(6,95,70,0.20)",
                  borderRadius: 16, padding: "16px 20px", marginBottom: 16,
                  boxShadow: "0 1px 3px rgba(6,95,70,0.06)" }}>
      <div style={{ fontSize: 16, fontWeight: 800, color: "#3D2A1C", marginBottom: 10 }}>
        حالات جاهزة
      </div>
      {loading && <div data-testid="ready-states-loading" style={{ fontSize: 12, color: "#78716C" }}>جارٍ التحميل…</div>}
      {err && <div data-testid="ready-states-error" style={{ fontSize: 12, color: "#B45309" }}>{err}</div>}
      {!loading && !err && (
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          {states.map((s) => (
            <button key={s.key} type="button"
                    data-testid={`ready-state-btn-${s.key}`}
                    onClick={() => setOpenState(s)}
                    style={{
                      display: "flex", flexDirection: "column", alignItems: "flex-start",
                      gap: 4, padding: "10px 16px", borderRadius: 12,
                      border: "1.5px solid #0F766E", background: "#F0FDFA",
                      cursor: "pointer", minWidth: 140, textAlign: "right",
                    }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: "#065F46" }}>{s.label_ar}</span>
              {s.subset_of_ar && (
                <span data-testid={`ready-state-subset-${s.key}`} style={{ fontSize: 10.5, color: "#57534E" }}>
                  ضمن «{s.subset_of_ar}»
                </span>
              )}
              <span data-testid={`ready-state-count-${s.key}`}
                    style={{ fontSize: 22, fontWeight: 900, color: "#065F46",
                             fontVariantNumeric: "lining-nums tabular-nums" }}>
                {s.count != null ? s.count.toLocaleString("en-US") : "—"}
              </span>
            </button>
          ))}
        </div>
      )}
      {openState && (
        <CustomerListModal
          kind="metric_state"
          segmentCode={openState.key}
          title={`حالة جاهزة — ${openState.label_ar}`}
          onClose={() => setOpenState(null)}
        />
      )}
    </div>
  );
}

export default ReadyStatesRow;
